import axios from "axios";

export const uploadToCloudinary = async (file) => {
  const url = `https://api.cloudinary.com/v1_1/dzqrscett/upload`;

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", "dummy_unsigned"); // Create a preset in Cloudinary > Settings > Upload

  try {
    const response = await axios.post(url, formData);
    return response.data.secure_url; // Returns uploaded image URL
  } catch (error) {
    console.error("Upload failed:", error);
    return null;
  }
};
